const STORAGE_PREFIX = 'rn-encrypted-storage:'

const canUseLocalStorage = () => {
  try {
    return typeof window !== 'undefined' && !!window.localStorage
  } catch {
    return false
  }
}

const getKey = (key) => `${STORAGE_PREFIX}${key}`

const EncryptedStorage = {
  async setItem(key, value) {
    if (!canUseLocalStorage()) return
    window.localStorage.setItem(getKey(key), String(value))
  },

  async getItem(key) {
    if (!canUseLocalStorage()) return null
    const value = window.localStorage.getItem(getKey(key))
    return value === null ? null : value
  },

  async removeItem(key) {
    if (!canUseLocalStorage()) return
    window.localStorage.removeItem(getKey(key))
  },

  async clear() {
    if (!canUseLocalStorage()) return
    const keysToRemove = []
    for (let index = 0; index < window.localStorage.length; index += 1) {
      const storageKey = window.localStorage.key(index)
      if (storageKey && storageKey.startsWith(STORAGE_PREFIX)) keysToRemove.push(storageKey)
    }
    keysToRemove.forEach((k) => window.localStorage.removeItem(k))
  },
}

module.exports = {
  __esModule: true,
  default: EncryptedStorage,
  ...EncryptedStorage,
}

